<template>
  <div id="app" :class="isPhone?'isPhone':''">
    <router-view />
  </div>
</template>

<script>
import store from './store/index'
export default {
  name: 'App',
  data() {
    return {
      isPhone: window.localStorage.getItem('isPhone') * 1
    }
  },
  mounted() {
    store.commit('setDeviceData', this.isPhone)
    window.addEventListener('resize', () => { //  resize:当调整浏览器窗口的大小时触发事件
      this.isPhone = window.localStorage.getItem('isPhone') * 1
      store.commit('setDeviceData', this.isPhone)
    })
  }
}
</script>

<style lang='less'>
#app {
  font-size: 14px;
  height: 100%;
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  user-select: none;
}
.isPhone {
  img {
    width: 100% !important;
    margin: 20px auto !important;
    height: auto !important;
  }
  video {
    width: 100% !important;
    height: auto !important;
  }
  .therapy-text {
    padding-left: 0;
  }
  .circle {
    padding-left: 15px;
  }
  .circle::before {
    left: 0px;
  }
  .vd-img-background-base {
    flex-direction: column;
    width: 100% !important;
    height: auto !important;
    padding: 24.4px !important;
  }
  .img-inner-text-base {
    width: 100% !important;
    height: auto !important;
  }
  .therapy-ul-diy {
    margin-left: 0;
  }
  .special-set {
    width: 100% !important;
    height: auto !important;
    .special-set-div1 {
      width: 14% !important;
    }
    .special-set-div2 {
      flex-direction: column;
      align-items: baseline;
      flex: auto;
    }
  }
  .center-line-title {
    font-size: 16px !important;
  }
  .center-line-title > .mark {
    font-size: 12px !important;
  }
  .v-btn-document {
    font-size: 16px !important;
  }
  .therapy-document {
    font-size: 12px !important;
  }
}
body *::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 5px;
}

body *::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #928c8c;
}

body *::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/App.vue